// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cPSf","footer":"styles_footer__3ExXx"};